import React, { Component } from 'react';
const BoardToken = 'a04bbb85-0aa3-ad40-63fa-cccedd40ee7d';

class indexClass extends Component {
  state = {
    callbackStatus: false,
  };

  changeStatus = () => {
    this.setState({
      callbackStatus: true
    }, () => {
      this.props.sendBackStatus();
    })
  }

  componentDidMount() {
    this.setCannyBlock();
  }

  setCannyBlock = () => {
    if (Boolean(this.props.ssoToken)) {
      (function (w, d, i, s) { function l() { if (!d.getElementById(i)) { var f = d.getElementsByTagName(s)[0]; var e = d.createElement(s); e.type = "text/javascript"; e.async = !0; e.src = "https://canny.io/sdk.js"; f.parentNode.insertBefore(e, f); } } if ("function" != typeof w.Canny) { var c = function () { c.q.push(arguments) }; c.q = []; w.Canny = c; "complete" === d.readyState ? l() : w.attachEvent ? w.attachEvent("onload", l) : w.addEventListener("load", l, !1) } })(window, document, "canny-jssdk", "script");
      window.Canny('render', {
        boardToken: BoardToken,
        basePath: '/dashboard/Feedback',
        ssoToken: this.props.ssoToken,
        onLoadCallback: () => {
          this.changeStatus();
        },
      });
    }
  }

  render() {
    return (
      <div>
        <div className="DetailReport_Empty_New_div_margin_1000">
          <div data-canny></div>
        </div>
      </div>
    );
  }
}

export default indexClass;